// extracted by mini-css-extract-plugin
module.exports = {"root":"Switch_root__20mlx","label":"Switch_label__1q3AN","active":"Switch_active__2NhVZ","spinAround":"Switch_spinAround__1127z"};